"use client";

import { useDiscoverPageAIContentPromise } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/DiscoverPageAIContentPromiseContextProvider";
import { IDiscoverPageAIContentResponse } from "@faire/web-api--source/indigofair/seo/IDiscoverPageAIContentResponse";
import React, { use } from "react";

export const DiscoverPageHeaderBannerAISubCopyRenderer: React.FC<{
  fallback: React.ReactNode;
}> = ({ fallback }) => {
  const aiContentPromise = useDiscoverPageAIContentPromise();
  if (!aiContentPromise) {
    return fallback;
  }
  const aiContent: IDiscoverPageAIContentResponse = use(aiContentPromise);
  return aiContent.sub_copy ? <>{aiContent?.sub_copy}</> : fallback;
};
